import { Stack } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { UnknownRights } from "src/pages/Admin/UnknownRights/Type";

import InputSearch from "./InputSearch";
import { SecurityType } from "./useGetSecuritiest";

export default function SecurityFinderRow({ security, id }: UnknownRights) {
	const client = useQueryClient();

	const onChange = (newValue: SecurityType) => {
		client.setQueryData(["adminUnknownRights"], (data?: UnknownRights[]) => {
			return (data || []).map((i) => (i.id === id ? { ...i, security: newValue } : i));
		});
	};

	return (
		<Stack sx={{ width: 400 }}>
			<InputSearch value={security} onChange={onChange} />
		</Stack>
	);
}
